module.exports = __webpack_public_path__ + "static/img/18.3491c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/18.png
// module id = 16K8
// module chunks = 2